import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import {VGMap} from "../../../../modules/index.esm";
import {VGLoadMore} from "vgloadmore";
import {normalizeData} from "../../../../modules/vegas/js/_util";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));
		VG.fixedHeader($(window));

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
		VG.fixedHeader($self);
	},

	onResize: ($self) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableLoadMore();
			VG.plugins.enableTyped();
		},

		enableVGNav: function () {
			new VGNav('.vg-nav', {
				expand: 'lg',
				toggle: '<i class="fa fa-chevron-down"></i>',
				isCollapse: false
			});
		},

		enableAOS: function ()  {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableNiceSelect: function ()  {
			//$('.nice-select').niceSelect();
		},

		enableLawCookie: function () {
			new VGLawCookie();
		},

		enableLoadMore: function () {
			[...document.querySelectorAll('.btn-load-more-photos')].forEach((el) => {
				new VGLoadMore(el, {}, {
					onLoad: function (self, data) {
						let view = normalizeData(data).view,
							target = document.getElementById(self.btn.dataset.target);

						target.insertAdjacentHTML('beforeEnd', view);
					}
				});
			});
		},

		enableTyped: function () {
			vgTyped.init('[data-typed]')
		}
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn ),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.header-wrapper'),
			scroll = $self.scrollTop(),
			$body = $('body');

		if (scroll > 0) {
			$body.addClass('header--is-fixed');
			$sticky.addClass('fixed');
		} else {
			$sticky.removeClass('fixed');
			$body.removeClass('header--is-fixed');
		}
	},
}


export default VGListener;